import { IActionPayload } from 'spw-redux/types';
import { IBuilding, IFloor } from 'spw-redux/modules/projects/types';
import { REQUEST_STATUS } from 'spw-constants';
import * as ouActions from './actions';
import { IRoundsState } from './types';

const initialState: IRoundsState = {
  spaceRounds: [],
  occupancyAndUtilizationSummaries: null,
  rounds: [],
  currentRound: null,
  loading: true,
  roundsRequestStatus: REQUEST_STATUS.NONE,
  currentRoundBuilding: null,
  currentRoundFloor: null,
  currentRoundSpaceCategory: 'individualWorkspaces',
  selectedRoundPhotos: [],
  reportZipFileName: '',
  usages: [],
};
const reducer = (
  state: IRoundsState = initialState,
  action: IActionPayload
) => {
  switch (action.type) {
    case ouActions.FETCH_PROJECT_ROUNDS:
      return {
        ...state,
        roundsRequestStatus: REQUEST_STATUS.QUERYING,
        loading: true,
      };
    case ouActions.FETCH_PROJECT_ROUNDS_SUCCEEDED:
      return {
        ...state,
        rounds: action.payload.rounds,
        selectedRoundsMap: action.payload.selectedRoundsMap,
        roundsRequestStatus: REQUEST_STATUS.SUCCESS,
        loading: false,
      };
    case ouActions.FETCH_SPACE_ROUNDS:
      return {
        ...state,
        roundsRequestStatus: REQUEST_STATUS.QUERYING,
        loading: true,
      };
    case ouActions.FETCH_SPACE_ROUNDS_SUCCEEDED:
      return {
        ...state,
        spaceRounds: action.payload.rounds,
        loading: false,
      };
    case ouActions.GET_OCCUPANCY_AND_UTILIZATION_SUMMARIES_SUCCEEDED:
      return {
        ...state,
        occupancyAndUtilizationSummaries:
          action.payload.occupancyAndUtilizationSummaries,
      };
    case ouActions.CLEAN_UP_OCCUPANCY_AND_UTILIZATION_SUMMARIES:
      return {
        ...state,
        occupancyAndUtilizationSummaries:
          initialState.occupancyAndUtilizationSummaries,
      };
    case ouActions.CLEAN_UP_OU:
      return {
        ...state,
        rounds: initialState.rounds,
        selectedRoundsMap: initialState.selectedRoundsMap,
        occupancyAndUtilizationSummaries:
          initialState.occupancyAndUtilizationSummaries,
      };
    case ouActions.SET_CURRENT_ROUND:
      return {
        ...state,
        currentRound: action.payload.round,
        currentRoundBuilding: null as IBuilding | null,
        currentRoundFloor: null as IFloor | null,
      };
    case ouActions.SET_CURRENT_ROUND_BUILDING:
      return {
        ...state,
        currentRoundBuilding: action.payload.building,
      };

    case ouActions.SET_CURRENT_ROUND_FLOOR:
      return {
        ...state,
        currentRoundFloor: action.payload.floor,
      };
    case ouActions.SET_CURRENT_ROUND_SPACE_CATEGORY:
      return {
        ...state,
        currentRoundSpaceCategory: action.payload.category,
      };
    case ouActions.POPULATE_ROUND_USAGES:
      return {
        ...state,
        usages: action.payload.usages,
      };
    case ouActions.POPULATE_ROUND_PHOTOS:
      return {
        ...state,
        selectedRoundPhotos: action.payload.photos,
      };
    case ouActions.SET_REPORT_ZIP_FILE_NAME:
      return {
        ...state,
        reportZipFileName: action.payload.zipFileName,
      };
    default:
      return state;
  }
};

export default reducer;
